import { Injectable } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllSuggestionsResponseModel, SuggestionsResponseModel } from '@gtpl/shared-models/hrms';
import { InjectRepository } from '@nestjs/typeorm';
import { Entity, getManager, Repository } from 'typeorm';
import { SuggestionsRequest } from './dto/suggestions.request';
import { SuggestionsDTO } from './dto/suggestions.dto';
import { SuggestionsAdapter } from './dto/suggestions.adapter';
import { Suggestions } from './suggestions.entity';


@Injectable()
export class SuggestionsService {

    constructor(
        @InjectRepository(Suggestions) 
        private suggestionsRepo: Repository<Suggestions>,
        private suggestionsAdapter: SuggestionsAdapter,
    ){}

    async getSuggestion(suggestion: string): Promise<Suggestions>{
        const response =  await this.suggestionsRepo.findOne({
            where: {suggestion: suggestion},
        });
        if(response){
            return response;
        } else{
            return null;
        }
    }

    async createSuggestion(data: SuggestionsDTO, isUpdate: boolean): Promise<SuggestionsResponseModel>{
        try{
            if(!isUpdate){
                const suggestionEntity = await this.getSuggestion(data.suggestion);
                if(suggestionEntity){

                    throw new ErrorResponse(11104, 'Suggestion already exists');
                }
            }else{
                const suggestionEntity = await this.getSuggestion(data.suggestion);
                if(suggestionEntity){
                    if(suggestionEntity.suggestionId != data.suggestionId){
                        throw new ErrorResponse(11104, 'Suggestion already exists');
                    }
                }
            }
            const convertedSuggestionEntity: Suggestions = this.suggestionsAdapter.convertDtoToEntity(data, isUpdate);
            console.log(convertedSuggestionEntity);
            const savedSuggestion: Suggestions = await this.suggestionsRepo.save(convertedSuggestionEntity);
            const convertedSuggestion: SuggestionsDTO = this.suggestionsAdapter.convertEntityToDto(savedSuggestion);

            if(convertedSuggestion){
                const response = new SuggestionsResponseModel(true, isUpdate? 11100: 11101, isUpdate? 'Suggestion updated successfully' : 'Suggestion created successfully', convertedSuggestion);
                return response;
            }else {
                throw new ErrorResponse(11106, 'Suggestion is saved but issue while transforming into DTO');
            }
        }catch(error){
            throw error;
        }
    }


    //     try{
    //         const suggestionsDto: SuggestionsDTO[] = [];
    //         const suggestionsEntities: Suggestions[] = await this.suggestionsRepo.find({
    //             order: { suggestion: 'ASC'},
    //         });
    //         console.log(suggestionsEntities+'ressssentity')

    //         if(suggestionsEntities.length > 0){
    //             suggestionsEntities.forEach(Entity => {
    //                 const convertedDto: SuggestionsDTO = this.suggestionsAdapter.convertEntityToDto(Entity);
    //                 suggestionsDto.push(convertedDto);
    //             });
    //             const response = new AllSuggestionsResponseModel(true, 11208, 'Suggestions retrieved successfully', suggestionsDto);
    //             console.log(suggestionsDto+'resssssxx')
    //             return response;
    //         }else{
    //             throw new ErrorResponse(99998, 'No Records Found');
    //         }
    //     }catch(error){
    //         throw error;
    //     }
    // }

    async getAllSuggestions():Promise<AllSuggestionsResponseModel>{
        try{
          const manager=getManager();
          const query = ' SELECT employee_code AS employeeCode,status AS status ,suggestion_id AS suggestionId,suggestion_name AS suggestion,suggestion_type AS suggestionType,s.department_id AS departmentId,remarks,STATUS,s.is_active AS isActive,department_name AS departmentName,s.employee_id AS employeeId,employeeName FROM erpx_dev_hrms.suggestions s LEFT JOIN `erpx_dev_masters`.`employee_details` ed ON s.employee_id = ed.employee_id'
          const result = await manager.query(query)
          if(result){
            return new AllSuggestionsResponseModel(true, 1111, "Data retreived sucessfully",result)          
          }else{
            return new AllSuggestionsResponseModel(false, 1111, "Error occure")
          
          }
            }
            catch(err){
            return err;
            }
          
        }
    async getSuggestionById(id: number): Promise<Suggestions>{
        const response = await this.suggestionsRepo.findOne({
            where: {suggestionId: id},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async activateOrDeactivateSuggestion(req: SuggestionsRequest): Promise<SuggestionsResponseModel>{
        try{
            const suggestionExists = await this.getSuggestionById(req.suggestionId);
            if(suggestionExists){
                if(req.versionFlag != suggestionExists.versionFlag){
                    throw new ErrorResponse(10113, 'Someone updated the current suggestion information. Refresh and try again');
                }else{
                    const suggestionStatus = await this.suggestionsRepo.update(
                        {suggestionId: req.suggestionId},
                        {isActive: req.isActive, updatedUser: req.updatedUser}
                    );
                    if(suggestionExists.isActive){
                        if(suggestionStatus.affected){
                            const response: SuggestionsResponseModel = new SuggestionsResponseModel(true, 10115, 'Suggestion is de-activated successfully');
                            return response;
                        }else{
                            throw new ErrorResponse(10111, 'Suggestion is already de-activated');
                        }
                    }else{
                        if(suggestionStatus.affected){
                            const response: SuggestionsResponseModel = new SuggestionsResponseModel(true, 10114, 'Suggestion activated successfully');
                            return response;
                        }else{
                            throw new ErrorResponse(10112, 'Suggestion is already activated');
                        }
                    }
                }
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(error){
            throw error;
        }
    }
}
